import React from "react";
import { Box, TextField } from "@mui/material";

const Field = ({
  label,
  value,
  onChange,
  multiline = false,
  placeholder = "",
  hint = "",
}) => (
  <Box mb={2}>
    <TextField
      fullWidth
      label={label}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      multiline={multiline}
      minRows={multiline ? 3 : undefined}
      placeholder={placeholder}
      helperText={hint}
      size="small"
      sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
    />
  </Box>
);

export default Field;